import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type State = {
  isOpen: boolean
}

export const recommendedDrawerSlice = createSlice({
  name: 'recommendedDrawer',
  initialState: {
    isOpen: false,
  },
  reducers: {
    setIsOpen: (_state, action: PayloadAction<boolean>): State => {
      return { isOpen: action.payload }
    },
  },
})

export const recommendedDrawerReducer = recommendedDrawerSlice.reducer
export const recommendedDrawerActions = recommendedDrawerSlice.actions
